import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./PostBlock').then(m => ({default: m.PostBlock})),
)

export const postBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
})
